import React from 'react';
import { map, find, isEmpty, get, noop } from 'lodash';
import classnames from 'classnames';

// Local Dependencies
import { Icon } from 'modules/icon-bank';
import { getDisplayValue } from 'resolvers/formatValue';
import { DATA_TYPES, CONTACT_TYPE } from 'constants/common';
import { getLabel } from 'utils/getLabel';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberCommunicationSettings as MemberCommunicationSettings } from 'ui/views/widgets/memberCommunicationSettings';
 *
 * // render
 * <MemberCommunicationSettings propName='propValue'/>
 */

// Contact detail view
const ContactDetail = ( props ) => {
        
    // extracting actions
    const editAction = find( props.modifyActions, { name: 'edit' } );
    const deleteAction = find( props.modifyActions, { name: 'delete' } );
    const defaultAction = find( props.modifyActions, { name: 'setDefault' } );

    const { showDefaultButton = true } = props;

    return (
        map( ( props.contacts ), field => {

            // extracting values needs to be displayed
            const displayValueForContactType = getDisplayValue( { type: DATA_TYPES.SINGLE_SELECT, value: field.type, options: props.options.contactType } );
            const displayValueForContactNumber = getDisplayValue( { type: DATA_TYPES.PHONE, value: field.contact } );
            const isDefault = get( field, 'flags.isDefault', false );

            // extracting actions Visibility
            const actionsVisibility = field.actionsVisibility;

            // dynamic className for Set Default Action
            const isDefaultClassName = classnames( 'ui-member-communication-settings__contact__type-detail__default', {
                'ui-member-communication-settings__contact__type-detail__default__is-default': isDefault,
                'ui-member-communication-settings__contact__type-detail__default--disabled': ! actionsVisibility.setDefault,
            } );

            // dynamic className for Edit Action
            const editClassName = classnames( 'ui-member-communication-settings__contact__actions__action', {
                'ui-member-communication-settings__contact__actions__action--disabled': ! actionsVisibility.edit,
            } );

            // dynamic className for Delete Action
            const deleteClassName = classnames( 'ui-member-communication-settings__contact__actions__action', {
                'ui-member-communication-settings__contact__actions__action--disabled': ! actionsVisibility.delete,
            } );

            return (
                <div key={ field.id } className='ui-member-communication-settings__contact'>

                    {/* Header Actions */}
                    <div className='ui-member-communication-settings__contact__type-detail'>
                        <div className='ui-member-communication-settings__contact__type-detail__type'>
                            { displayValueForContactType }
                        </div>
                        {
                            showDefaultButton ? (
                                <div className={ isDefaultClassName }
                                    onClick={ ( actionsVisibility.setDefault && ! isDefault ) ? ( () => props.makeDefaultClickHandler( { item: field } ) ) : null}>
                                    { getLabel( get( defaultAction, 'title', {} ) ) }
                                </div>
                            ) : null
                        }
                    </div>
                    
                    {/* contact number/ email */}
                    <div className='ui-member-communication-settings__contact__contact-number'>
                        {
                            CONTACT_TYPE.EMAIL === field.type ? (
                                <span  className='ui-member-communication-settings__contact__contact-number__email-icon'>
                                    <Icon name='email' />
                                </span>
                            ) : null
                        }
                        <span className='ui-member-communication-settings__contact__contact-number__text'>
                            { displayValueForContactNumber }
                        </span>
                    </div>

                    {/* the partition */}
                    <div className='ui-member-communication-settings__contact__partition' />

                    {/* footer Actions */}
                    <div className='ui-member-communication-settings__contact__actions'>
                        <div className={ editClassName } onClick={ actionsVisibility.edit ? ( () => props.addEditClickHandler( { action: editAction, mode: 'edit', field: field } ) ) : null }>
                            <div className='ui-member-communication-settings__contact__actions__action__icon'>
                                <Icon name='edit' fill={ actionsVisibility.edit ? THEME.themeColorPrimary2 : '#7a7a7a' } />
                            </div>
                            <div className='ui-member-communication-settings__contact__actions__action__name'>
                                { getLabel( get( editAction, 'title', {} ) ) }
                            </div>
                        </div>
                        <div className={ deleteClassName } onClick={ actionsVisibility.delete ? ( () => props.deleteClickHandler( { item: field } ) ) : null }>
                            <div className='ui-member-communication-settings__contact__actions__action__icon'>
                                <Icon name='delete' fill={ actionsVisibility.delete ? THEME.themeColorPrimary2 : '#7a7a7a' } />
                            </div>
                            <div className='ui-member-communication-settings__contact__actions__action__name'>
                                { getLabel( get( deleteAction, 'title', {} ) ) }
                            </div>
                        </div>
                    </div>
                </div>
            );
        } )
    );
};

// set display name
ContactDetail.displayName = 'memberCommunicationSettings.contactDetail';

/*----------------- */

export const memberCommunicationSettings = ( props ) => {
    
    // extracting add action
    const addAction = props.addAction;
    const checkContacts = isEmpty(props.contacts)
    console.log(checkContacts,"checkin add action")

    const { actionClassName, disableAddNewButton = false } = props;

    const _actionClassName = classnames( 'ui-member-communication-settings__add-new', actionClassName, {
        'ui-member-communication-settings__add-new--disabled': disableAddNewButton
    } );
    console.log(actionClassName)

    const iconClassName = classnames( 'ui-member-communication-settings__add-new__icon', {
        'ui-member-communication-settings__add-new__icon--disabled': disableAddNewButton
    } );

    const titleClassName = classnames( 'ui-member-communication-settings__add-new__title', {
        'ui-member-communication-settings__add-new__title--disabled': disableAddNewButton
    } );

    return (
        
        <div className='ui-member-communication-settings'>
            
            { ( isEmpty( checkContacts ) && !props.hideAddNew && !isEmpty(addAction) ) && (
                <div className={ _actionClassName } onClick={ disableAddNewButton ? noop : () => props.addEditClickHandler( { action: addAction, mode: 'add'  } ) }>
                    <div className={ iconClassName }>
                        <Icon name='add' />
                    </div>
                    <div className={ titleClassName }>
                        { getLabel( addAction.title ) }
                    </div>
                </div>
            )  } 
            { ( !isEmpty( checkContacts ) && props.hideAddNew  && !isEmpty(addAction) )   && (
                <div className={ _actionClassName } onClick={ disableAddNewButton ? noop : () => props.addEditClickHandler( { action: addAction, mode: 'add'  } ) }>
                    <div className={ iconClassName }>
                        <Icon name='add' />
                    </div>
                    <div className={ titleClassName }>
                        { getLabel( addAction.title ) }
                    </div>
                </div>
            )  } 
            
            <ContactDetail { ...props }/>
            
            
        </div>
        
                   
    );
            
};

// set display name
memberCommunicationSettings.displayName = 'memberCommunicationSettings';

// set default props
memberCommunicationSettings.defaultProps = {};

// prop types
memberCommunicationSettings.propTypes = {};

